import React from 'react'
import Icons from '@/components/icons'
// import productApis from '@/apis/product'

interface PillProps {
  label: string
  iconName: string
  variant?: 'filled' | 'outlined'
}

const Pill: React.FC<PillProps> = ({ label, iconName, variant = 'outlined' }) => {
  return (
    <div
      className={[
        'inline-flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium',
        variant === 'outlined'
          ? 'border border-gray-300 text-gray-700 bg-[#FAFAFA]'
          : 'bg-gray-100 text-gray-700'
      ].join(' ')}
    >
      {iconName !== '' && (
        <Icons name={iconName} size={16} />
      )}
      {label}
    </div>
  )
}

interface SectionProps {
  whyShop?: Array<{ label: string, iconName: string }>
  discoverProducts?: string[]
  discoverShops?: string[]
}

const WhyShopSection: React.FC<SectionProps> = ({
  whyShop = [
    { label: 'Free Delivery', iconName: 'scooter' },
    { label: 'Free Replacements', iconName: 'replacements' },
    { label: 'Guaranteed Freshness', iconName: 'freshness' }
  ],
  discoverProducts = ['Free Delivery', 'Free Replacements', 'Guaranteed Freshness'],
  discoverShops = ['Shops in Kandivali East', 'Fruit & Vegetable Shops in Kandivali East', 'Guaranteed Freshness']
}) => {
  // const getChildCategory = () => {
  //   productApis.getCatApi('get', null, latLng, productId)
  //     .then((res: any) => {
  //       setChildCatSeo({
  //         ...childCatSeo,
  //         childCat: res.data.childs,
  //         parent: res.data.parent,
  //         childCatErr: false
  //       })
  //     })
  //     .catch(() => {
  //       setChildCatSeo({
  //         ...childCatSeo,
  //         childCat: null,
  //         parent: null,
  //         childCatErr: false
  //       })
  //     })
  // }

  return (
    <div className="mt-10 space-y-6 lg:px-4">
      {/* Why Shop */}
      <div>
        <h2 className="text-base font-semibold mb-3">Why shop at LoveLocal</h2>
        <div className="flex flex-wrap gap-3">
          {whyShop.map((item) => (
            <Pill key={item.label} label={item.label} iconName={item.iconName} />
          ))}
        </div>
      </div>

      {/* Discover more products */}
      {/* <div>
        <h2 className="text-base font-semibold mb-3">Discover more products</h2>
        <div className="flex flex-wrap gap-3">
          {discoverProducts.map((p) => (
            <Pill key={p} label={p} variant="outlined" iconName='' />
          ))}
        </div>
      </div> */}

      {/* Discover more shops */}
      {/* <div>
        <h2 className="text-base font-semibold mb-3">Discover more shops</h2>
        <div className="flex flex-wrap gap-3">
          {discoverShops.map((s) => (
            <Pill key={s} label={s} variant="outlined" iconName='' />
          ))}
        </div>
      </div> */}
    </div>
  )
}

export default WhyShopSection
